import React, { ReactNode } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ReactComponent as Circle } from '../MessageBox/icons/icon-info-circle.svg';

export interface IBlueInfoBox {
    Info: string;
    ExtraInfo?: string;
    Buttons?: ReactNode;
    style?: any;
    fullWidth?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainBoxDiv: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: '0.75rem 1.5rem',
            backgroundColor: '#F1F9FF',
            borderRadius: '8px',
            width: 'fit-content',
            flexDirection: 'row',
            flexWrap: 'wrap',
            '& >p': {
                fontSize: '0.875rem',
                color: '#616161',
                margin: '0 0 0 1rem',
                fontWeight: 600,
            },
        },
    }),
);
const BlueInfoBox = (props: IBlueInfoBox) => {
    const classes = useStyles();

    return (
        <div
            className={classes.mainBoxDiv}
            style={{
                ...props.style,
                width: props.fullWidth ? '100%' : 'fit-content',
            }}
        >
            <Circle width="1rem" height="1rem" />
            <p>
                {props.Info} {props.ExtraInfo ?? ''}
            </p>
            {props.Buttons && <div>{props.Buttons}</div>}
        </div>
    );
};

export default BlueInfoBox;
